<app-autocomplete-select
  placeholder="{{'search.user' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
